// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v5-spinner-lines{text-align:center;font-size:.32rem}.v5-spinner-lines>div{background-color:#ff552e;height:100%;width:.106667rem;border-radius:.0533333333rem;display:inline-block;animation:sk-stretchdelay 1.2s ease-in-out infinite}.v5-spinner-lines .rect2{animation-delay:-1.1s}.v5-spinner-lines .rect3{animation-delay:-1s}.v5-spinner-lines .rect4{animation-delay:-.9s}@keyframes sk-stretchdelay{0%,40%,to{transform:scaleY(.4)}20%{transform:scaleY(.8)}}", ""]);
// Exports
module.exports = exports;
